import { Spinner } from "react-bootstrap";
import { useContext } from 'react';
import StateContext from '../context/State';



const LoadingSpinner = () => {
    const { state } = useContext(StateContext);


    return (
        <div style={{ 
            height: '80%', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center', 
            alignItems: 'center',
            textAlign: 'center'
        }}>
            {state.progressMessage && (
                <div style={{ maxWidth: '500px', marginBottom: '2rem' }}>
                    <p className="text-muted" style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
                        {state.progressMessage}
                    </p>
                    <p className="text-warning" style={{ marginBottom: '0.5rem' }}>
                        <strong>Please do not close your browser</strong>
                    </p>
                    <p className="text-muted" style={{ fontSize: '0.9rem', marginBottom: '0' }}>
                        This process may take a few seconds
                    </p>
                </div>
            )}
            <Spinner
                animation="border"
                role="status"
                style={{
                    height: '100px',
                    width: '100px',
                    marginBottom: '2rem'
                }}
            />
        </div>
    )
}


export default LoadingSpinner;
